import endpoints from "api/endpoints";

export default (
  { resultKey = "isBankDeleted", bankId } = { resultKey: "isBankDeleted" }
) => ({
  url: endpoints.getActionBankUrl(bankId),
  transform: (response) => !response.error,
  transformResult: (response) => ({
    [resultKey]: !response.error,
  }),
  queryKey: endpoints.getActionBankUrl(),
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: "application/json",
    },
    method: "DELETE",
  },
  update: {},
  updateResult: {
    [resultKey]: (prevResult, result) => result,
  },
});
